export const TITLE_MAX = 100;
export const PRAISE_BEHAVIOR_MAX = 2000;

// An idea's "What do you want to fix or improve?" and "What should we do?". Together, with the blank line
// joining them, they stay within the 5000-character body that older ideas are written in.
export const IDEA_PROBLEM_MAX = 2500;
export const IDEA_SOLUTION_MAX = 2000;

// Per-file upload cap. nginx allows a little more so multipart overhead never trips it first.
export const MAX_UPLOAD_MB = 10;
export const MAX_UPLOAD_BYTES = MAX_UPLOAD_MB * 1024 * 1024;
